import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TenapodExternalRedirectAuthComponent } from './tenapod-external-redirect-auth/tenapod-external-redirect-auth.component';

const routes: Routes = [{ path: '', component: TenapodExternalRedirectAuthComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TenapodExternalRedirectAuthRoutingModule {}
